<template>
  <div class="news_inner" v-if="content !== undefined">
    <BlogInnerHeader :news_title="content.title" :news_tags="tags_news" />
    <div class="news_inner__content bg-whitewc-lg">
      <section :class="' container  news_inner__content--' + block.type"
        v-for="(block, index) in _.get(content.content, 'tabs')" :key="index">
        <div :class="'news_inner__content--' + block.type + '__inner'" v-if="block.type == 'main_block'">
          <div class="news_inner__content--img_wrapper">
            <picture>
              <source media="(max-width: 1365px)" :srcset="_.get(block, 'image[0].devices.tablet')" />
              <source media="(max-width: 767px)" :srcset="_.get(block, 'image[0].devices.mobile')" />

              <img :src="_.get(block, 'image[0].devices.desktop')" :alt="_.get(content, 'title')" class="br-12 cover" />
            </picture>
          </div>
          <p class="f-38 light uppercase wc-lg">{{ _.get(block, "teaser") }}</p>
        </div>

        <div :class="'news_inner__content--' + block.type + '__inner'" v-if="block.type == 'video_block'">
          <div class="news_inner__content--img_wrapper pointer" @click="show_video()">
            <div class="pointer news_inner__content--video_block__play-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="59.999" height="60" viewBox="0 0 59.999 60">
                <path id="Combined_Shape" data-name="Combined Shape"
                  d="M30,60A30.008,30.008,0,0,1,18.323,2.358,30.008,30.008,0,0,1,41.677,57.642,29.814,29.814,0,0,1,30,60ZM26.881,21.97a2.508,2.508,0,0,0-2.506,2.5V35.526a2.5,2.5,0,0,0,3.811,2.129l8.979-5.526a2.5,2.5,0,0,0,0-4.258l-8.979-5.527A2.493,2.493,0,0,0,26.881,21.97Z"
                  fill="#fff" />
              </svg>
            </div>

            <video class="cover">
              <source :poster="_.get(content, 'content.video_desktop.videoFile.url#t=0.1')
                " :src="_.get(content, 'video_desktop.videoFile.url')" />
            </video>
          </div>
          <div class="news_inner__content--video_block__text_box flex bg_gray">
            <div class="wc-lg news_inner__content--video_block__text_box__text flex column">
              <h2 class="f-38 bold">{{ _.get(block, "title") }}</h2>
              <p class="f-14 medium wc-lg">{{ _.get(block, "teaser") }}</p>
              <div class="news_inner__content--video_block__socials flex">
                <a :href="_.get(icon, 'url')" target="_blank" class="news_inner__content--video_block__socials--icon"
                  v-html="_.get(icon, 'svg')" v-for="(icon, index) in _.get(block, 'buttons')" :key="index"></a>
              </div>
            </div>
          </div>
        </div>

        <div :class="'wc-lg news_inner__content--' + block.type + '__inner'" v-if="block.type == 'news_description'">
          <h2 class="f-38 bold uppercase f-white">{{ block.title }}</h2>
          <p class="f-18 medium f-white">{{ block.teaser }}</p>
        </div>

        <div :class="'wc-lg news_inner__content--' + block.type + '__inner'" v-if="block.type == 'advantages'">
          <h2 class="f-38 bold uppercase news_inner__content--advantages__title">
            {{ _.get(block, "title") }}
          </h2>
          <div class="news_inner__content--advantages--editor" v-html="_.get(block, 'content')"></div>
          <router-link :to="_.get(block, 'buttons[0].url')"
            class="news_inner__content--advantages--btn button bg-light-purple pointer">
            <svg id="Group_5_Copy_3" data-name="Group 5 Copy 3" xmlns="http://www.w3.org/2000/svg" width="11.352"
              height="11.351" viewBox="0 0 11.352 11.351">
              <path id="Combined_Shape_Copy_2" data-name="Combined Shape Copy 2"
                d="M5.007,11.074a.946.946,0,0,1,0-1.338L8.122,6.622H.946a.946.946,0,0,1,0-1.892H8.121L5.007,1.615A.946.946,0,1,1,6.344.277l4.73,4.729.016.017.008.009.008.008.01.011.006.006.011.012,0,0,.011.014,0,0,.011.014,0,0,.011.015,0,0,.01.015,0,0,.009.014,0,.005.008.013,0,.007.007.011.006.01,0,.009.007.013,0,.006.009.017v0a.946.946,0,0,1-.194,1.1L6.344,11.074a.946.946,0,0,1-1.338,0Z"
                fill="#fff" />
            </svg>

            <span class="f-14 bold uppercase f-white">{{
              _.get(block, "buttons[0].title")
            }}</span>
          </router-link>
        </div>

        <div :class="'news_inner__content--' + block.type + '__inner'" v-if="block.type == 'simple_banner'">
          <div class="news_inner__content--img_wrapper">
            <picture>
              <source media="(max-width: 1365px)" :srcset="_.get(block, 'image[0].devices.tablet')" />
              <source media="(max-width: 767px)" :srcset="_.get(block, 'image[0].devices.mobile')" />

              <img :src="_.get(block, 'image[0].devices.desktop')" :alt="$route.name == 'PageViewRouter_ge'
                  ? block.seo_keywords_ge
                  : block.seo_keywords_en
                " class="cover" data-scroll-speed="-1.8" data-scroll />
            </picture>
          </div>
        </div>

        <div :class="'wc-lg news_inner__content--' + block.type + '__inner'" v-if="block.type == 'two_grid_block'">
          <h2 class="f-38 bold uppercase news_inner__content--two_grid_block--title">
            {{ _.get(block, "title") }}
          </h2>
          <div class="news_inner__content--two_grid_block--editor" v-html="_.get(block, 'content')"></div>
        </div>

        <div :class="'wc-lg news_inner__content--' + block.type + '__inner'" v-if="block.type == 'one_grid_block'">
          <h2 class="f-38 bold uppercase news_inner__content--one_grid_block--title">
            {{ _.get(block, "title") }}
          </h2>
          <div class="news_inner__content--one_grid_block--editor" v-html="_.get(block, 'content')"></div>
        </div>

        <div :class="'wc-lg news_inner__content--' + block.type + '__inner'" v-if="block.type == 'quote'">
          <h2 class="f-38 light uppercase news_inner__content--quote--title">
            {{ _.get(block, "teaser") }}
          </h2>
        </div>

        <div :class="'flex a_center j_center br-12 news_inner__content--' +
          block.type +
          '__inner'
          " v-if="block.type == 'small_banner'">
          <div class="news_inner__content--small_banner--overlay bg-overlay"></div>
          <div class="news_inner__content--img_wrapper">
            <picture>
              <source media="(max-width: 1365px)" :srcset="_.get(block, 'image[0].devices.tablet')" />
              <source media="(max-width: 767px)" :srcset="_.get(block, 'image[0].devices.mobile')" />

              <img :src="_.get(block, 'image[0].devices.desktop')" class="cover" :alt="$route.name == 'PageViewRouter_ge'
                  ? block.seo_keywords_ge
                  : block.seo_keywords_en
                " />
            </picture>
          </div>
          <div class="news_inner__content--small_banner__text-box flex column a_center">
            <h2 class="f-38 bold uppercase f-white wc-lg">
              {{ _.get(block, "title") }}
            </h2>
            <h2 class="f-38 bold uppercase f-white wc-lg">
              {{ _.get(block, "teaser") }}
            </h2>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import resize_handler from "@/mixins/resize_handler";
import BlogInnerHeader from "@/components/modules/BlogInnerHeader";
export default {
  mixins: [resize_handler],
  props: ["contentData"],
  data() {
    return {
      video_layer: false,
      video_start: false
    };
  },

  components: {
    BlogInnerHeader
  },
  mounted() {
    console.log(this.$store.state.main.selected_menu_locales.en)
  },
  computed: {
    content() {
      return _.get(
        this.$store.state.main.current_content,
        "primary.data.list[0]"
      );
    },
    tags_news() {
      let _tags = this.$store.state.main.indx.terms.tags_news;
      let tags = _tags.filter(tag => this.content.tags_news.includes(tag.id));
      return tags;
    },
    get_home_link() {
      return this.$store.state.main.indx.menus.filter(m => m.set_home == 1)[0]
        .full_url;
    },
  },
  methods: {
    show_video() {
      let V = document.querySelector(".news_inner__content--video_block video");
      let BTN = document.querySelector(
        ".news_inner__content--video_block__play-btn"
      );
      V.setAttribute("controls", "");
      BTN.style.opacity = "0";
    }
  },

  watch: {
    content: {
      immediate: true,
      handler(ns) {
        if (ns === undefined) {
          this.$router.push({ path: this.get_home_link });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.news_inner__content--main_block__inner{
  width: 100%;
}

.show_layer-enter-active,
.show_layer-leave-active {
  transition: transform 1.5s cubic-bezier(0.22, 1, 0.36, 1);

  @media (max-width: 1365px) {
    transition: 0.5s;
  }
}

.show_layer-enter,
.show_layer-leave-to {
  @media (min-width: 1366px) {
    transform: translateX(-100%);
  }

  @media (max-width: 1365px) {
    opacity: 0;
  }
}


</style>

<style lang="scss">
.news_inner__content--advantages--editor,
.news_inner__content--two_grid_block--editor,
.news_inner__content--one_grid_block--editor {
  ul {
    list-style-type: none;
    padding-left: 41px;

    @media (max-width: 767px) {
      padding-left: 22px;
    }
  }

  li {
    position: relative;

    &:after {
      position: absolute;
      left: 0;
      top: 9px;
      content: "";
      font-weight: bold;
      display: inline-block;
      width: 8px;
      height: 8px;
      margin-left: -22px;
      background-color: #7063e9;
      border-radius: 50%;
    }
  }
}
</style>
